module.exports = __webpack_public_path__ + "static/media/snow_fall_500.82f5e8e3.gif";